import React, { useState } from 'react';
import { Add } from '@gjensidige/builders-icons';
import { Button } from '@gjensidige/builders-components';
import { IPricingQuestion } from '../../interfaces/EnquiryInterface';
import { AppConstants } from '../../utils/AppConstants';
import { AddInputsModal } from './AddInputsModal';

interface AddInputsWidgetProps {
  addInputsSectionLabel: string;
  hideAddInputsButton: boolean;
  additionalModalInputs: IPricingQuestion[];
  addAdditionalQuestions: () => void;
  resetAdditionalQuestions: () => void;
  handleModalInputChange: (
    type: string,
    value: string,
    isValid?: boolean
  ) => void;
}
export const AddInputsWidget: React.FC<AddInputsWidgetProps> = (
  props: AddInputsWidgetProps
) => {
  const [isOpen, setIsOpen] = useState(false);
  const onModalClose = (event?: any) => {
    //event && event.preventDefault();
    setIsOpen(false);
  };
  const primaryButtonAction = () => {
    setIsOpen(false);
  };
  const handleSubmit = () => {
    props.addAdditionalQuestions();
    setIsOpen(false);
  };

  const handleAddButtonClick = () => {
    props.resetAdditionalQuestions();
    setIsOpen(true);
  };

  return (
    <>
      {!props.hideAddInputsButton && (
        <div className="add-inputs-label-wrapper">
          <Button
            variant="secondary"
            onClick={handleAddButtonClick}
            icon={<Add />}
            iconPosition="left"
            id="add-additional-inputs"
            aria-describedby="add-additional-inputs-info"
          >
            {props.addInputsSectionLabel}
          </Button>
        </div>
      )}
      <AddInputsModal
        isOpen={isOpen}
        modalHeader={AppConstants.getAppText(
          'webshop.villa.addAdditionalBuildingModalHeader'
        )}
        criticalButtonLabel={AppConstants.getAppText(
          'webshop.villa.extraBuildingAddButtonLabel'
        )}
        primaryButonLabel={AppConstants.getAppText(
          'webshop.villa.extraBuildingCancelButtonLabel'
        )}
        onInputChange={props.handleModalInputChange}
        onModalClose={onModalClose}
        primaryButtonAction={primaryButtonAction}
        additionalModalInputs={props.additionalModalInputs}
        criticalButtonAction={handleSubmit}
        closeBtnLabel="Avbryt att lägga till byggnad"
        modalLabel="Lägg till övrig byggnad"
      />
    </>
  );
};
